import React, { Component } from 'react'
import phoneFormatter from 'phone-formatter'
import { History } from 'history'

import {
  Carfax,
  EmploymentAndIncome,
  HandleInsufficientFunds,
  InsurancePolicy,
  Lienholder,
  LienholderInputs,
  Mileage,
  Registration,
  ReviewFraud,
  SignLoanAgreement,
  Text,
  VerifyData,
  VerifyFunds,
} from './taskBodies'

import { Task, LienholderInfo } from './types'
import { FormProps as LienholderFormProps } from './taskBodies/lienholderInputs'

export interface Props {
  task: Task
  history?: History
  location?: Location
}

export class TaskDetails extends Component<Props> {
  static displayName = 'TaskDetails'

  filterTasks = (task: Task) => {
    switch (task.taskType) {
      case 'CARFAX_FRAUD_REVIEW':
        return <Carfax task={task} />
      case 'CONTACT_LIENHOLDER':
      case 'UPDATE_LIENHOLDER_INFO':
        const lienholder = task.verifiables[0] as LienholderInfo
        return (
          <div>
            <Lienholder task={task} />
            {lienholder && lienholder.id && (
              <LienholderInputs
                initialValues={{ id: lienholder.id } as LienholderFormProps}
                task={task}
                history={this.props.history}
              />
            )}
          </div>
        )
      case 'HANDLE_INSUFFICIENT_FUNDS':
        return (
          <HandleInsufficientFunds
            phone={phoneFormatter.format(task.user.phone, '(NNN) NNN-NNNN')}
          />
        )
      case 'INSURANCE_POLICY':
        return <InsurancePolicy task={task} />
      case 'PROOF_OF_EMPLOYMENT':
        return <EmploymentAndIncome task={task} />
      case 'REGISTRATION':
        return <Registration task={task} />
      case 'REVIEW_FOR_FRAUD':
        return <ReviewFraud task={task} />
      case 'REVIEW_USER_DATA_MISMATCH':
      case 'REVIEW_PLAID_DATA_MISMATCH':
        return <VerifyData task={task} />
      case 'SIGN_LOAN_AGREEMENT':
        return <SignLoanAgreement task={task.id} />
      case 'TEXT':
        return <Text task={task} />
      case 'VERIFY_FUNDS':
        return <VerifyFunds task={task} />
      case 'VERIFY_MILEAGE':
        return <Mileage task={task} />
      default:
        return null
    }
  }

  render() {
    const { task } = this.props
    return <div>{this.filterTasks(task)}</div>
  }
}

export default TaskDetails
